import { useEffect } from "react";
const useScrollIntoView = ({ containerRef, targetRef }, dependencies) => {
  useEffect(() => {
    const container = containerRef.current;
    const target = targetRef.current;
    if (!container) return;
    if (container.scrollHeight > container.clientHeight) {
      const scrollBottom = container.clientHeight + container.scrollTop;
      const targetTop = target ? target.offsetTop : 0;
      const targetBottom = target ? target.offsetTop + target.offsetHeight : 0;
      if (targetBottom > scrollBottom) container.scrollTop = targetBottom - container.clientHeight;
      if (targetTop < container.scrollTop) container.scrollTop = targetTop;
    }
  }, [containerRef, targetRef, ...dependencies]);
};
export {
  useScrollIntoView as default
};
//# sourceMappingURL=useScrollIntoView.es.js.map
